import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { IonPopover } from '@ionic/angular';
import { format, parseISO, isValid } from 'date-fns';

@Component({
  selector: 'app-datetime-picker-input',
  templateUrl: './datetime-picker-input.component.html',
  styleUrls: ['./datetime-picker-input.component.scss'],
})
export class DatetimePickerInputComponent implements OnInit {
  public uniqueId = Math.random().toString(36).substring(2, 9);

  @Input() label: string = 'Data e Hora';
  @Input() value: string = ''; // ISO string: '2026-05-12T15:27:00'
  @Input() required: boolean = false;
  @Input() customError: string = '';
  @Input() hideErrors: boolean = true;
  @Input() showInvalidError: boolean = false;

  @Output() valueChange = new EventEmitter<string>();

  @ViewChild('popover') popover!: IonPopover;

  public internalIsoValue: string = '';
  public formattedDisplayValue: string = '';
  public wasCalendarOpened: boolean = false;

  ngOnInit() {
    if (this.value) {
      this.updateValues(this.value);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !changes['value'].firstChange) {
      this.updateValues(this.value);
    }
  }

  public onDatetimeChange(event: any) {
    const selectedIsoString = event.detail.value;

    if (selectedIsoString) {
      this.updateValues(selectedIsoString);
      this.valueChange.emit(this.internalIsoValue);
      this.popover.dismiss();
    }
  }

  calendarOpened() {
    this.wasCalendarOpened = true;
  }

  private updateValues(isoString: string) {
    this.internalIsoValue = isoString;

    try {
      const parsedDate = parseISO(isoString);
      if (isValid(parsedDate)) {
        this.formattedDisplayValue = format(parsedDate, 'dd/MM/yyyy HH:mm');
      } else {
        this.formattedDisplayValue = '';
      }
    } catch (e) {
      this.formattedDisplayValue = '';
    }
  }
}
